function NewsSearch() {
	this.init();
}

NewsSearch.prototype.init = function() {
	$(".nsearchBtn").on("click", function(e) {
		e.preventDefault();
		var btn = $(this).attr('data-baseUrl');
		var searchValue = $(".nsearch").val().trim();
		
		if (searchValue === "") {
			alert("Wpisz wartość w pole wyszukiwania");
			return;
		}
		
		var encodedValue = encodeURIComponent(searchValue);
		var url = btn+"&nsearch=" + encodedValue;
		
		window.location.href = url;
	});
	$(".nsearch").on('keydown', function(e) {
		if(e.key == 'Enter') {
			e.preventDefault();
			$(".nsearchBtn").click();
		}
	});

	var lang = $('html').attr('lang');
	var labels = {
		pl: { short: 'Przeszukaj', long: 'Przeszukaj aktualności' },
		en: { short: 'Browse', long: 'Browse the news' } 
	};
	$(window).on('resize load', function() {
		var $search = $(".nsearch");
		
		if ($search.length) {
			var isMobile = $(this).width() <= 1200;
			$search.attr('placeholder', isMobile ? labels[lang].short : labels[lang].long);
		}
	});

	//console.log('Init NewsSearch');
};